// @flow
/* -----------------Globals--------------- */
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation InviteMutation(
    $intentId: ID!
  ) {
    invite(
      intentId: $intentId
    )
  }
`;

const invite = async (
  intentId: string,
  environment: *,
): Promise<Boolean> => {
  const promise = new Promise((resolve, reject) => {
    const variables = {
      intentId,
    };
    commitMutation(environment, {
      mutation,
      variables,
      onCompleted: (response) => {
        if (response.invite) resolve(response);
      },
      onError: (err) => {
        reject(err);
      },
    });
  });
  return promise;
};

export default invite;
